import React, { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../../CSS/Main/portfolio.scss';
import PortfolioImage from '../../../Images/portfolio.jpg';
import {ArrowLeft} from 'react-feather';
import { fetchData } from '../../../Utility/GlobalService';
import getUrl from '../../../Utility/GetUrl';
import Carousel from '../../../Pages/Dashboard/Pages/Portfolio/Sub-Page/Components/Carousel';
import {Dots} from 'react-preloaders2';

const PortfolioContentSingle = ()=> {
    const {id} = useParams();
    const [portfolio, setPortfolioData] = useState();
    const [loading,setLoading] = useState(true);
    useEffect(()=>{
        getPortfolio(id);
        setLoading(false);
    },[]);
    const getPortfolio = async(id)=>{
      const response = await fetchData(`${getUrl()}/work/${id}`);
      setPortfolioData(response);
      // console.log(response);
    }
return (
  <Fragment>
    <Dots background="#000" color="#00FFA5" customLoading={loading}/>
    <div className="container">
      <div>
        <div className="row">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="contents">
              <div className="portfolio-image">
                {portfolio && <Carousel images={portfolio.images} height='100%' width='100%'/>}
              </div>
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>
        <div className="row">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="project-stack">
              {portfolio && <h5 className="header_or_link">{portfolio.projectname}<span></span></h5>}
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>
        <div className="row">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="project-stack">
              {portfolio && 
              <div style={{textAlign: 'justify'}}
              dangerouslySetInnerHTML={{__html: portfolio.description}}
              className="header_or_link"></div>}
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>

        <div className="row mt-3">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="project-stack">
              <h5 className="header_or_link">TECHNOLOGIES
                {portfolio && portfolio.technologies.map((technology)=>{
                return (<span key={technology._id}> #{technology.name} </span>)
                })
                }
              </h5>
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>

        <div className="row">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="project-stack">
              {portfolio && <h5 className="header_or_link">LIVE LINK #<span>
                <a className="header_or_link" href={portfolio.livelink}>{portfolio.livelink}</a>
                </span></h5>}
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>
        <div className="row mt-5 pb-5">
          <div className="col-md-2 col-lg-2"></div>
          <div className="col-md-8 col-lg-8">
            <div className="project-link">
            <Link className="portfolio_link" to={`/main/portfolio/`}>
                  GO BACK
                  <span><ArrowLeft className="porfolio_arrow_icon"/></span>
            </Link>
            </div>
          </div>
          <div className="col-md-2 col-lg-2"></div>
        </div>
        
        
      </div>
    </div>
  </Fragment>
);
}

export default PortfolioContentSingle;